import { render, staticRenderFns } from "./TheDocument.vue?vue&type=template&id=1a301a5d&scoped=true&"
import script from "./TheDocument.vue?vue&type=script&lang=js&"
export * from "./TheDocument.vue?vue&type=script&lang=js&"
import style0 from "./TheDocument.vue?vue&type=style&index=0&id=1a301a5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a301a5d",
  null
  
)

export default component.exports